export default "__VITE_ASSET__DBm72P8X__"